import { ReactNode } from 'react';

import { GrowthBookPayload } from '@growthbook/growthbook-react';

import { ForcedFeatures } from '@app/state/helpers/cookie-app-router.helpers';

import { GrowthbookBaseProvider } from './growthbook-base.provider';

export const GrowthbookPagesProvider = ({
    payload,
    forcedFeatures,
    children,
}: {
    payload: GrowthBookPayload | null;
    forcedFeatures: ForcedFeatures;
    children: ReactNode;
}) => (
    <GrowthbookBaseProvider payload={payload} forcedFeatures={forcedFeatures}>
        {children}
    </GrowthbookBaseProvider>
);
